import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { ratingTypes } from 'shared/constants/ratingTypes';
import { getAuthDataOrganisationId, getAuthDataUserId } from 'selectors/auth';
import { requestCreditReviewRatings, fetchEntities } from 'services';
import { Loader } from 'ui';
import { CreditReview, SummaryCardRequestCreditReview } from 'modules/creditReview';
import { useFeatures } from 'shared/hooks/useFeatures/useFeatures';

const CreditReviewTab = ({ easyNumber }) => {
  const features = useFeatures();
  const organisationId = useSelector(getAuthDataOrganisationId);
  const userId = useSelector(getAuthDataUserId);
  const [ratingAvailable, setRatingAvailable] = useState(false);
  const [entity, setEntity] = useState();
  const [isPending, setIsPending] = useState(false);
  const [isRequestRatingPending, setIsRequestRatingPending] = useState(false);

  const fetchData = async () => {
    setIsPending(true);

    const { data } = await fetchEntities(
      {
        page: 1,
        limit: 1,
        query: easyNumber, // TODO: change to { filter: { easyNumber } } when backend is ready
        userId,
      },
      ratingTypes.CREDIT_REVIEW,
    );

    if (data && data.length) {
      const entityData = data[0];

      setEntity(entityData);
      setRatingAvailable(entityData.wasRequested);
    }

    setIsPending(false);
  };

  useEffect(() => {
    if (features.creditReview) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRatingRequest = async () => {
    setIsRequestRatingPending(true);

    const response = await requestCreditReviewRatings({
      ids: [easyNumber],
      userId,
      organisationId,
    });

    if (response.success) {
      fetchData();
      setRatingAvailable(true);
      setIsRequestRatingPending(false);
    }
  };

  if (!features.creditReview || !easyNumber) {
    return <SummaryCardRequestCreditReview isAvailable={false} />;
  }

  if (!entity) {
    return <Loader center />;
  }

  return (
    <CreditReview
      ratingAvailable={ratingAvailable}
      entity={entity}
      easyNumber={easyNumber}
      isPending={isPending}
      isRequestRatingPending={isRequestRatingPending}
      handleRatingRequest={handleRatingRequest}
    />
  );
};

CreditReviewTab.defaultProps = {
  easyNumber: undefined,
};

CreditReviewTab.propTypes = {
  easyNumber: PropTypes.string,
};

export default CreditReviewTab;
